(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["eb-product-next"] && !Shopify.designMode) return;
  try {
    function easyBoothQuoteSelection(event) {
 const link = event.target.closest?.('[data-eb-product-quote]');
 if (!link) return;
 const section = link.closest('[id^="shopify-section-"]');
 const form = section?.querySelector('form[action*="/cart/add"]');
 const variantId = form?.querySelector('input[name="id"]')?.value;
 const quantityField = section?.querySelector('input[name="quantity"]');
 const quantity = Math.max(1, parseInt(quantityField?.value || '1', 10) || 1);
 const productUrl = new URL(link.dataset.productUrl, window.location.origin);
 if (variantId) productUrl.searchParams.set('variant', variantId);
 const selectedOptions = [...(section?.querySelectorAll('variant-picker input[type="radio"]:checked, variant-picker select') || [])].map(input => input.value).filter(Boolean);
 const variantTitle = selectedOptions.length ? selectedOptions.join(' / ') : link.dataset.variantTitle;
 const summary = [quantity + ' × ' + link.dataset.productTitle];
 if (variantTitle && variantTitle !== 'Default Title') summary.push(variantTitle);
 summary.push(productUrl.href);
 const target = new URL(link.href);
 target.searchParams.set('product', summary.join('\n'));
 link.href = target.href;
}
document.addEventListener('click', easyBoothQuoteSelection);
document.addEventListener('auxclick', easyBoothQuoteSelection);
  } catch(e) { console.error(e); }
})();

})();
